import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { HowtoIndex } from "../components/howto/HowtoIndex";
import { howtoIndexHead } from "../lib/howto/head";
import { howtoIndexPath, loadHowto } from "../lib/howto/index";
import { HOWTO_UI } from "../lib/howto/ui";
import { siteLangOf } from "../lib/marketing/registry";
import { documentHeaders } from "../lib/seo";

/** The guides hub in a non-English language, at `/<lang>/how-to`. */
export const Route = createFileRoute("/$lang/how-to/")({
  loader: async ({ params }) => {
    const lang = siteLangOf(params.lang);
    if (!lang) throw notFound();

    const path = howtoIndexPath(lang);
    if (path !== `/${params.lang}/how-to`)
      throw redirect({ href: path, statusCode: 301 });

    return { lang, bundle: await loadHowto(lang) };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? howtoIndexHead(
          loaderData.lang,
          HOWTO_UI[loaderData.lang],
          loaderData.bundle,
        )
      : {},
  component: LocalizedGuides,
});

function LocalizedGuides() {
  const { lang, bundle } = Route.useLoaderData();
  return <HowtoIndex lang={lang} ui={HOWTO_UI[lang]} bundle={bundle} />;
}
